var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resource-item"},[_c('div',{staticClass:"resource-item__row"},[_c('UserCard',{attrs:{"account":_vm.observer}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }